export default "/_next/static/src/lib/assets/rive/e0c0401db69de404870b940989734320.riv";